/*
** Import the SDK
*/

import firebase from 'firebase/app'
import firestore from 'firebase/firestore'
import auth from 'firebase/auth'
import storage from 'firebase/storage'

/*
** Set the Firebase config variables
*/

let firebaseResidentsConfig = {

	apiKey: String(process.env.VUE_APP_RESIDENTS_FIREBASE_API_KEY),
	projectId: String(process.env.VUE_APP_RESIDENTS_FIREBASE_PROJECT_ID),
	appId: String(process.env.VUE_APP_RESIDENTS_FIREBASE_APP_ID)

};

/*
** Initialize Firebase in apps
*/

const residentsApp = firebase.initializeApp(firebaseResidentsConfig, 'secondary');

/*
** Export the Nestd individual services
*/

export const residentsFirestoreDB = residentsApp.firestore();

/*
** Export the Nestd models
*/

export const residentsUsersModel = residentsFirestoreDB.collection('users');